import React, { useState, useImperativeHandle, forwardRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { LocalKeyMap } from '@/local';
import { CenterPopup } from 'antd-mobile'
import CSSModules from 'react-css-modules'
import styles from './index.module.scss'

const ChargePopup=(props,ref)=> {
  const {className, style }=props
  const [visible, setVisible] = useState(false)
  const { t } = useTranslation();
  const navigate = useNavigate()

  useImperativeHandle(ref, ()=> ({
    open: () => {
      setVisible(true)
    },
  }))

  const goToRecharge = (type)=> {
    navigate(`/recharge?type=${type}`)
  }

  return (
    <CenterPopup
        className={styles.wrap}
        bodyClassName={`${styles.chargeWrapInner}`}
        mask={true}
        onMaskClick={()=>{
          setVisible(false)
        }}
        // className={styles.centerWrap}
        visible={visible}>
      <div className={styles.header}>
        <div className={styles.tit}>
          {t(LocalKeyMap['charge.methodSelection'])}
        </div>
        <div className={styles.desc}>
          {t(LocalKeyMap['charge.methodSelectionDesc'])}
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.list}>
          <div className={styles.item}
            onClick={()=>{
              goToRecharge('fincode')
            }}>
            <div className={styles.label}>
              {t(LocalKeyMap['charge.creditCard'])}
            </div>
            <div className={styles.desc}>
              <img src={require('./images/credit_card.svg').default} alt="" />
            </div>
            <div className={styles.arrow}></div>
          </div>
          <div className={styles.item}
            onClick={()=>{
              goToRecharge('bankTransfer')
            }}>
            <div className={styles.label}>
              {t(LocalKeyMap['charge.bankTransferTit'])}
            </div>
            <div className={styles.desc}>
              <span>
                {t(LocalKeyMap['charge.bankTransferDesc'])}
              </span>
            </div>
            <div className={styles.arrow}></div>
          </div>
        </div>
      </div>
      <div className={styles.footer}
        onClick={()=>{
          setVisible(false)
        }}>
        <div className={styles.btn}>
          {t(LocalKeyMap['close'])}
        </div>
      </div>
    </CenterPopup>
  )
}
export default forwardRef(ChargePopup)